import { SET_SITE_INIT } from '../constants/ActionTypes';
import { AnyAction } from 'redux';

export function setSiteInit(key: boolean): AnyAction {
  return {
    type: SET_SITE_INIT,
    key,
  };
}
